import { render, staticRenderFns } from "./OpenMenuFooter.vue?vue&type=template&id=efdadef8&scoped=true&"
import script from "./OpenMenuFooter.vue?vue&type=script&lang=js&"
export * from "./OpenMenuFooter.vue?vue&type=script&lang=js&"
import style0 from "./OpenMenuFooter.vue?vue&type=style&index=0&id=efdadef8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdadef8",
  null
  
)

export default component.exports